import { Component, OnInit } from '@angular/core';
import {UserService} from '../../service/user.service';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ScrollToConfigOptions, ScrollToService} from '@nicky-lenaers/ngx-scroll-to';
import {OwlOptions} from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-outbound',
  templateUrl: './outbound.component.html',
  styleUrls: ['./outbound.component.css']
})
export class OutboundComponent implements OnInit {
  package: any;
  category: any;
  extra: any;
  details: any;
  isloading: boolean;
  packages: any;
  totalRec: any;
  page: any;
  pack: any;

  constructor(private userService:UserService,private route:Router,private modalService: NgbModal,private scrollToService: ScrollToService,) { }
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: false,
    pullDrag: false,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: {
        items: 2
      },
      600: {
        items: 5
      },
      900: {
        items: 8
      }
    },
    nav: false
  };
  ngOnInit(): void {
    // this.getallCatogry();
    this.triggerScrollTo();
    this.getallPackages(1);

  }

  // getallCatogry(){
  //   this.userService.getallCategorys().subscribe(
  //       res=>{
  //         this.category = res.data;
  //         this.package = res.data;
  //         this.extra = res.data;
  //         this.pacbyCategory(this.category[0].id);
  //       }
  //   )
  // }

  getallPackages(pageIndex){
    let req ={
      type:2
    }
    let size = 10;
    let page = pageIndex - 1;
    this.userService.packageSearch2(req,size,page).subscribe(
        res => {
          if (res.responseCode == 200) {
            this.pack =res['data']['content'];
            this.page = res['data']['number'];
            this.totalRec = res['data']['totalElements'];
          } else {
            // this.notifier.notify('danger', res.responseDesc);
          }
        }
    )
  }

  catogrySearch(id){
    // let req ={
    //   type:id,
    // }
    // this.userService.getallCategorys(req).subscribe(
    //     res=>{
    //       this.package = res.data;
    //     }
    // )
  }

  search(pac) {
    console.log(pac)
    let ar: Array<any> = [];
    ar.push(pac);
    this.package=ar;
  }

  all() {
    this.package =this.extra;
  }

  booking(p: any) {
    localStorage.setItem('package',JSON.stringify(p));
    this.route.navigate(['/package-details']);
  }

  open(content,details) {
    this.details=details;
    console.log(details);
    this.modalService.open(content, { centered: true });
  }

  custom(){
    this.route.navigate(['/index-custom-booking']);
  }

  pacbyCategory(id) {
    let ar =[]
    this.package=null;
    this.isloading =true;
    this.userService.getPackagebyCategory(id).subscribe(
        res=>{
          if(res.responseCode==200){
            this.isloading=false;
          }
          ar.push(res.data);
          this.package =ar;
        }
    )
  }

  triggerScrollTo() {

    const config: ScrollToConfigOptions = {
      target: 'home'
    };

    this.scrollToService.scrollTo(config);
  }
}
